import styled, { css } from "styled-components";

import Grid from "core/Grid";

import { handleBottomSpacing } from "js/helpers/spacingAndFonts";
import { convertPxToRem } from "frontend/components/helpers";

import breakpoints from "core/breakpoints";
import { BorderBottomLinkStyle } from "core/Typography";

export const Image = styled.div`
    ${handleBottomSpacing({ bottomSpacing: "lg" })}

    ${({ alignment }) =>
        css`
            text-align: ${alignment ? alignment : "center"};
        `}

    svg, img {
        /* Mobile + tablet: */
        @media (max-width: ${breakpoints.beforeDesktop.rem}) {
            width: ${convertPxToRem({ px: 100 })};
            height: ${convertPxToRem({ px: 100 })};
        }

        /* Desktop-only: */
        @media (min-width: ${breakpoints.desktop.rem}) {
            width: ${convertPxToRem({ px: 190 })};
            height: ${convertPxToRem({ px: 190 })};
        }
    }
`;

export const GridItem = styled(Grid)`
    a {
        ${BorderBottomLinkStyle}
    }
`;
